import * as z from 'zod'
import { WorkflowBlock } from '..'

export const workflowTriggerTypes = {
  layoutBlock: 'layout-block',
  listBlock: 'list-block',
  eventBlock: 'event-block',
  commit: 'commit',
} as const
export type WorkflowTriggerType =
  (typeof workflowTriggerTypes)[keyof typeof workflowTriggerTypes]

export const workflowTriggerEvents = {
  created: 'created',
  updated: 'updated',
  deleted: 'deleted',
} as const
export type WorkflowTriggerEvent =
  (typeof workflowTriggerEvents)[keyof typeof workflowTriggerEvents]

export type RunTriggerEvent = {
  [Type in WorkflowTriggerType]: `${Type}.${(typeof triggerTypeToAllowedEvents)[Type][number]}`
}[WorkflowTriggerType]

export const triggerTypeToAllowedEvents = {
  [workflowTriggerTypes.layoutBlock]: [workflowTriggerEvents.updated] as const,
  [workflowTriggerTypes.listBlock]: [
    workflowTriggerEvents.created,
    workflowTriggerEvents.updated,
    workflowTriggerEvents.deleted,
  ] as const,
  [workflowTriggerTypes.eventBlock]: [workflowTriggerEvents.created] as const,
  [workflowTriggerTypes.commit]: [workflowTriggerEvents.created] as const,
} as const

export type TriggerTypeToAllowedEvents = typeof triggerTypeToAllowedEvents

export const workflowTriggerSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal(workflowTriggerTypes.layoutBlock),
    layoutBlockId: z.string().nullable(),
    blockIds: z.array(z.string()),
    events: z.array(
      z.enum(triggerTypeToAllowedEvents[workflowTriggerTypes.layoutBlock])
    ),
  }),
  z.object({
    type: z.literal(workflowTriggerTypes.listBlock),
    blockId: z.string(),
    events: z
      .array(z.enum(triggerTypeToAllowedEvents[workflowTriggerTypes.listBlock]))
      .nullable(),
  }),
  z.object({
    type: z.literal(workflowTriggerTypes.eventBlock),
    blockId: z.string(),
    events: z.array(
      z.enum(triggerTypeToAllowedEvents[workflowTriggerTypes.eventBlock])
    ),
  }),
  z.object({
    type: z.literal(workflowTriggerTypes.commit),
    events: z.array(
      z.enum(triggerTypeToAllowedEvents[workflowTriggerTypes.commit])
    ),
  }),
])

export type WorkflowTrigger = z.infer<typeof workflowTriggerSchema>

export type WorkflowBlockChange = WorkflowBlock & {
  value: { trigger: { type: 'layout-block' } }
}
